import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import styled, { css } from "styled-components";
import { FlexColumn, FlexRow } from "../../../../../Common/Styles";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: ${ThisGorillaUtils.convertPxToRem("505")}rem;
  & > div {
    border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
    background: lightgray;
  }
`;

export const ModalBodyContainer = styled(FlexColumn)`
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-5"].value}rem;
`;

const sliderThumbCss = css`
  width: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  height: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border-radius: 50%;
  cursor: pointer;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
  border: 3px solid
    ${({ theme }) => theme.Color.border["ui-border-emphasize-brand"].value};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
`;
export const CustomSlider = styled.input<{ $value: number }>`
  margin: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
  -webkit-appearance: none;
  width: 100%;
  height: ${({ theme }) => theme.spacing["spacing-05"].value}rem;
  border-radius: 60px;
  cursor: pointer;
  background: ${({ $value, theme }) =>
    `linear-gradient(90deg, ${theme.Color.background.brand.default.value} ${$value}%,${theme.Color.background.brand.subtler["default-hover"].value} ${$value}%)`};

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    ${sliderThumbCss}
  }

  &::-moz-range-thumb {
    ${sliderThumbCss}
  }
`;

export const SliderContainer = styled(FlexRow)`
  align-items: center;
  width: 100%;
`;

export const Image = styled.img`
  width: 100%;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  max-width: 100%;
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  left: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
